import { useEffect, useState } from 'react';
import { PortfolioWorksContent, Filter } from './styles';

interface Project {
    id: number,
    image: string,
    title: string,
    category: string,
    url: string,
    techs: string[]
}

export function PortfolioWorks() {
    const [listProjects, setListProjects] = useState<Project[]>([])
    const [category, setCategory] = useState<string>('todos');
    const [activeCategory, setActiveCategory] = useState('todos')

    useEffect(() => {
        fetch('./services/projects.json', {
            headers: {
                Accept: 'application/json'
            }
        }).then(response => response.json())
            .then(data => setListProjects(data.projects))
    }, [])

    //Listando todas as categorias
    const allCategories = listProjects.map((project) => project.category)

    //Pegando uma única categoria
    const uniqueCategories = allCategories.filter((category, index) => allCategories.indexOf(category) === index);
    
    //Adicionando no início do Array de UniqueCategories a opção de todos
    uniqueCategories.unshift('todos')

    //Lista com os projetos filtrados
    const filteredProjects = category !== 'todos' ? 
        listProjects.filter((project) => project.category === category) 
        : listProjects

    //Função de Clique no Botão da Categoria
    const handleClickButtonCategory = (category:string) => {
        setCategory(category);
        setActiveCategory(category);

    }
    
    return (
        <>
            <Filter>
                {uniqueCategories.map((category)=>{
                    return(
                        <div key={category}>
                            <button className={activeCategory === category ? "active-button" : ""}
                                onClick={() => handleClickButtonCategory(category)}
                            >
                                {category}</button>
                        </div>
                    )
                })}
            </Filter>
            <PortfolioWorksContent>
                {filteredProjects.map((project) => {
                    return (
                        <div key={project.id}>
                            <img src={project.image} alt={project.title} />
                            <span>{project.category}</span>
                            <h3>{project.title}</h3>
                            <p>{project.techs.join(' | ')}</p>
                            <a href={project.url} target="_blank" rel="noopener noreferrer" >Ver projeto</a>
                        </div>
                    )
                })}

            </PortfolioWorksContent>
        </>
    )
}